"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.USER_OWNERSHIPS = exports.UserOwnership = void 0;
const enum_util_1 = require("./enum-util");
var UserOwnership;
(function (UserOwnership) {
    UserOwnership["Tendium"] = "Tendium";
    UserOwnership["Byggfakta"] = "Byggfakta";
    UserOwnership["Clira"] = "Clira";
})(UserOwnership = exports.UserOwnership || (exports.UserOwnership = {}));
exports.USER_OWNERSHIPS = (0, enum_util_1.getValuesFromEnum)(UserOwnership);
